import { useWatch } from "react-hook-form";
import { CPropertyValidationDocumentKeys } from "@rf/property/module/components/property-form/util/schemas/validation-documents/validation-document.schema";
import { C_YES_AND_NOT } from "@/src-refactor/modules/shared/model/const/yes-and-not.conts";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";

const useHasConfotur = () => {
  const hasConfotur = useWatch({
    name: CPropertyValidationDocumentKeys.has_confotur,
    defaultValue: []
  });

  return {
    YES: hasConfotur.some(
      (item: I_GENERIC_ITEMS) => item.value === C_YES_AND_NOT.YES.value
    ),
    NOT: hasConfotur.some(
      (item: I_GENERIC_ITEMS) => item.value === C_YES_AND_NOT.NOT.value
    )
  };
};

export default useHasConfotur;
